import { useIntl } from "react-intl";

import { OrderStatusSection } from "@/features/bookings/components/OrderStatusSection";
import { ReservationDocumentList } from "@/features/bookings/components/ReservationDocumentList";
import { ReservationNextSteps } from "@/features/bookings/components/ReservationNextSteps";
import { ReservationPaymentDetails } from "@/features/bookings/components/ReservationPaymentDetails";
import type { ReservationStatus } from "@/features/bookings/types/types";
import { FlightReservationSegmentsData } from "@/features/flights/components/FlightReservationSegmentsData";
import type { FindUserReservationFlightReservation } from "@/types/codegen";

type Props = {
  status: ReservationStatus;
  reservation: FindUserReservationFlightReservation;
};

export const MyFlight = ({ status, reservation }: Props) => {
  const intl = useIntl();

  return (
    <>
      <OrderStatusSection status={status} />

      <FlightReservationSegmentsData
        itinerary={reservation.externalReservation}
      />

      <section className="section-card mt-2 mb-4 flex w-full items-center justify-between gap-4">
        <span className="section-title mb-0">
          {intl.formatMessage({
            defaultMessage: "Ticket number",
            description:
              "Label for the flight ticket / booking reference number",
          })}
        </span>
        <span className="text-base font-semibold text-text-title">
          {reservation.externalReservation.reference.external}
        </span>
      </section>

      <ReservationDocumentList reservationId={reservation.reservationId} />

      <section>
        <h3 className="section-title mt-4">
          {intl.formatMessage({
            defaultMessage: "Passenger list",
            description:
              "Section heading for the passenger list in the booking summary",
          })}
        </h3>
        <ul
          className="section-card flex w-full flex-col gap-4"
          data-sentry-mask
        >
          {reservation.externalReservation.travelers.map((traveler) => (
            <li
              className="text-text-title"
              key={`${traveler.firstName}${traveler.lastName}`}
            >
              {traveler.firstName} {traveler.lastName}
            </li>
          ))}
        </ul>
      </section>

      <ReservationPaymentDetails reservation={reservation} />
      <ReservationNextSteps type="flight" />
    </>
  );
};
